<script>
import ConfigureCircuit from './ConfigureCircuit.vue'
import CircuitList from './CircuitList.vue'

export default {
    name: 'DynamicCircuit',
    props: ['circuit'],
    components: {
        ConfigureCircuit,
        CircuitList
    },
    computed: {
        renderComponent(){
            if (!this.circuit) {
                return 'configure-circuit'
            }
            if (this.circuit.type === '') {
                return 'configure-circuit'
            }
            else if (this.circuit.type === 'timer') {
                return 'circuit-list'
            }
            else if (this.circuit.type === 'reps') {
                return 'circuit-list'
            }
            return 'configure-circuit'
        }
    }
};
</script>
<template>
    <component v-bind:is="renderComponent" :circuit="circuit"></component>
</template>